import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn.js';

export interface EmptyStateProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

export const EmptyState = ({
  icon,
  title,
  description,
  action,
  className,
  ...rest
}: EmptyStateProps) => (
  <div
    className={cn(
      'flex flex-col items-center justify-center rounded-lg border border-dashed border-border bg-surface px-6 py-12 text-center',
      className,
    )}
    {...rest}
  >
    {icon && (
      <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-muted text-muted-fg">
        {icon}
      </div>
    )}
    <h2 className="text-base font-semibold text-fg">{title}</h2>
    {description && <p className="mt-1 max-w-md text-sm text-muted-fg">{description}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);
